import React from "react"
import ActionButton from "./actionbutton.component"
import { ButtonProps } from "../types/button"
import Icon from "../icon/icon.component"
import { FormattedMessage } from "react-intl"


export const MarkAsDoneButton = (props: ButtonProps) => {

    return (
        <ActionButton
            isLoading={props.isLoading ?? false}
            className={"btn-outline-success btn mr-2"}
            onClick={props.onClickCallback}>
            <Icon value={"bullseye"} className={"mr-1"} />
            <FormattedMessage
                id="common.placeholder.mark_as_done"
                defaultMessage="Mark as done"
            />
        </ActionButton>
    )
}


// WEBPACK FOOTER //
// ./src/common/button/MarkAsDoneButton.tsx